import cityUrlsData from "../constants/pet-shipping/pet_city_urls.json"
import boatsUrlData from "../constants/boats/boats-city.json"
import vehiclesData from "../constants/vehicles/index.json"
import { urlifyComplexName } from "@/constants/stateCityDictionary"

interface CityUrls {
  [key: string]: string | undefined
}

const cityUrls: CityUrls = cityUrlsData as CityUrls

export const getCityUrl = (
  cityName: string,
  classification?: string,
): string | undefined => {
  if (classification === "boats") {
    return (
      (boatsUrlData as Record<string, string>)[urlifyComplexName(cityName)] ??
      undefined
    )
  }

  if (classification === "vehicles") {
    // Find the vehicle city data
    const vehicleCity = vehiclesData.find(
      (item) => item.city.toLowerCase() === cityName.toLowerCase(),
    )

    if (vehicleCity) {
      return `/vehicle-transportation/${urlifyComplexName(
        vehicleCity.state,
      )}/${urlifyComplexName(vehicleCity.city)}`
    }

    return undefined
  }

  return cityUrls[cityName]
}

export type { CityUrls }
